import * as React from 'react';
import { connect } from 'react-redux';
import { companySelectors, TCompanyRootReducer } from '@company/features/index.company';
import NotificationTypes, { default as ENotificationTypes } from '@company/enums/NotificationTypes';
import { removeNotification } from '@company/features/action.company';
import { INotificationAction, INotificationComponent, TNotificationComponent } from './INotification';

import * as style from './notificationComponentStyle.module.scss'
let interval = 0;

export class NotificationComponent extends React.Component<INotificationComponent, TNotificationComponent> {
  static notificationTimeout:number = 5 * 1000;

  state: TNotificationComponent = {
    notificationsList:[],
    currentTime: new Date(),
  };

  checkTime = () => {
    const { notificationsList } = this.state;
    let { currentTime } = this.state;
    notificationsList.map((notification, index) => {
      if (notification.type === NotificationTypes.info) {
        if (currentTime.getTime() > notification.created_at.getTime() + NotificationComponent.notificationTimeout) {
          this.props.removeNotification(index);
        }
      }
    });
    currentTime = new Date();
    this.setState({ currentTime });
  }

  componentDidMount() {
    interval = window.setInterval(this.checkTime, 1000);
    const currentTime = new Date();
    this.setState({ currentTime, notificationsList: this.props.notificationsList });
  }

  UNSAFE_componentWillReceiveProps(nextProps:INotificationComponent) {
    if (nextProps.notificationsList !== this.state.notificationsList) {
      this.setState({ notificationsList:nextProps.notificationsList });
    }
  }

  componentWillUnmount() {
    window.clearInterval(interval);
  }

  render() {
    const { notificationsList } = this.state;
    return (
      <React.Fragment>
        <div className={style.notificationsList}>
          {notificationsList.map((notification, index) => (
            <div
              key={notification.created_at.getTime()}
              className={[style.notification,style[NotificationTypes[notification.type]]].join(' ')}
            >
              {notification.message}
              {
                notification.actions && notification.actions.length > 0 &&
                  this.renderActions(notification.actions,index,notification.type)
              }
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }

  private renderActions(actions: INotificationAction[], actionIndex:number, type:ENotificationTypes) {
    return (
      <React.Fragment>
        {
          actions.map((action,index) => (
            <button
              className={[style.btn,style[NotificationTypes[type]]].join(' ')}
              key={index}
              onClick={() => {action.callback(actionIndex);}}
            >
              {action.label}
            </button>
          ))
        }
      </React.Fragment>
    );
  }
}


const mapStoreToProps = (store:TCompanyRootReducer) => {
  return {
    notificationsList: companySelectors.getNotificationsList(store),
  };
};
const mapDispatchToProps = (dispatch: Function) => {
  return {
    removeNotification: (index: number) => {
      dispatch(removeNotification(index));
    },
  };
};

export default connect(mapStoreToProps, mapDispatchToProps)(NotificationComponent);
